import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { useData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IFaturaItem } from '@model/FaturaItem';
import { useFaturaService } from '@services/FaturaService';
import React from 'react';

export type FaturaDetalheModalProps = {
    modal: IModalWindow
    faturaId: number
}

export function FaturaDetalheModal ({ modal, faturaId }: FaturaDetalheModalProps) {
    const loading = useLoading();
    const message = useMessage();
    const formatter = useFormatter();
    const faturaItemData = useData<IFaturaItem>();
    const faturaService = useFaturaService();

    const handleEnter = React.useCallback(() => {
        if (!loading.isLoading) {
            loading.start();
            faturaService.listarItens(faturaId)
                .then(faturaItemData.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [faturaId, faturaItemData.handleDataResponse, faturaService, loading, message.showException]);

    return (
        <ModalWindow 
            modal={modal}
            size="md"
            disabled={loading.isLoading}
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Detalhes da Fatura ${faturaId}`}
            />

            <TableLinearLoading isLoading={loading.isLoading} />

            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Descrição</TableHeaderCell>
                        <TableHeaderCell>Contrato ID</TableHeaderCell>
                        <TableHeaderCell>Valor</TableHeaderCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {
                        faturaItemData.items.map((faturaItem, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{faturaItem.faturaItemId}</TableKeyCell>
                                    <TableCell>{faturaItem.descricao}</TableCell>
                                    <TableCell>{faturaItem.contratoClienteId}</TableCell>
                                    <TableCell>{formatter.toFloat(faturaItem.valorTotal)}</TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{formatter.toFloat(faturaItemData.items.reduce((a, b) => a + (b.valorTotal || 0), 0))}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </ModalWindow>
    )
}